import React, { useState } from "react";
import { Layout, Typography, Form, Input, Button, Select, message, Row, Col } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { Option } = Select;

const RequestAIDemo = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    setTimeout(() => {
      message.success("Your AI demo request has been submitted successfully!");
      setLoading(false);
    }, 2000);
  };

  return (
    <Layout>
      <Content style={{ padding: "50px", background: "#f0f2f5", minHeight: "100vh" }}>
        <Row gutter={[32, 32]} align="middle">
          {/* Left Column: Background Image with Text */}
          <Col xs={24} md={12} style={{ position: "relative", height: "500px" }}>
            <div
              style={{
                backgroundImage: "url('https://images.unsplash.com/photo-1620712943543-bcc4688e7485?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80')", // AI-themed image
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100%",
                borderRadius: "8px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0, 0, 0, 0.5)", // Dark overlay for readability
                  padding: "40px",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Title level={2} style={{ color: "#fff", marginBottom: "20px" }}>
                  How to Request an AI Demo
                </Title>
                <Paragraph style={{ color: "#fff", fontSize: "16px" }}>
                  <CheckCircleOutlined style={{ marginRight: "8px" }} />
                  Fill out the form with your details.
                </Paragraph>
                <Paragraph style={{ color: "#fff", fontSize: "16px" }}>
                  <CheckCircleOutlined style={{ marginRight: "8px" }} />
                  Select your preferred AI solution.
                </Paragraph>
                <Paragraph style={{ color: "#fff", fontSize: "16px" }}>
                  <CheckCircleOutlined style={{ marginRight: "8px" }} />
                  Submit and await our response within 24-48 hours.
                </Paragraph>
              </div>
            </div>
          </Col>

          {/* Right Column: Form */}
          <Col xs={24} md={12}>
            <div style={{ background: "#fff", padding: "24px", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}>
              <Title level={3} style={{ fontSize: "24px", color: "#1890ff" }}>
                Request an AI Demo
              </Title>
              <Paragraph style={{ fontSize: "16px", color: "#666", marginBottom: "24px" }}>
                Experience the power of AI with a personalized demo tailored to your needs.
              </Paragraph>
              <Form layout="vertical" onFinish={onFinish}>
                <Form.Item
                  label="Full Name"
                  name="name"
                  rules={[{ required: true, message: "Please enter your name" }]}
                >
                  <Input placeholder="John Doe" size="large" />
                </Form.Item>

                <Form.Item
                  label="Email Address"
                  name="email"
                  rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}
                >
                  <Input placeholder="example@domain.com" size="large" />
                </Form.Item>

                <Form.Item
                  label="Company/Organization"
                  name="company"
                  rules={[{ required: true, message: "Please enter your company name" }]}
                >
                  <Input placeholder="Your Company Name" size="large" />
                </Form.Item>

                <Form.Item
                  label="Select AI Solution"
                  name="aiSolution"
                  rules={[{ required: true, message: "Please select an AI solution" }]}
                >
                  <Select placeholder="Choose an AI Solution" size="large">
                    <Option value="chatbot">AI Chatbot</Option>
                    <Option value="fraudDetection">Fraud Detection</Option>
                    <Option value="medicalAI">Medical Diagnosis AI</Option>
                    <Option value="tradingBot">Crypto Trading Bot</Option>
                    <Option value="custom">Custom AI Solution</Option>
                  </Select>
                </Form.Item>

                <Form.Item label="Additional Information (Optional)" name="additionalInfo">
                  <Input.TextArea rows={4} placeholder="Provide any additional details" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }}
                  >
                    Submit Request
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default RequestAIDemo;